document.addEventListener('DOMContentLoaded', function() {
  const sliderSections = document.querySelectorAll('.custom-category-slider');

  sliderSections.forEach(sliderSection => {
    const sectionId = sliderSection.dataset.sectionId;
    const sliderSettings = {
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    };

    function initializeSlick(selector) {
      const slider = $(selector);
      if (slider.length && !slider.hasClass('slick-initialized')) {
        // Wait for jQuery and Slick to be available
        if (typeof $ !== 'undefined' && typeof $.fn.slick !== 'undefined') {
          try {
            // Destroy existing slider if any
            if (slider.hasClass('slick-initialized')) {
              slider.slick('unslick');
            }
            
            // Initialize the slider
            slider.slick(sliderSettings);
            
            // Add smooth transition class after initialization
            slider.addClass('slick-ready');
            
            // Hide loading indicator
            slider.find('.slider-loading').fadeOut(300);
            
            // Force a refresh to ensure proper layout
            setTimeout(() => {
              if (slider.hasClass('slick-initialized')) {
                slider.slick('refresh');
              }
            }, 100);
            
          } catch (error) {
            console.error('Error initializing slider:', error);
            // Retry after a delay
            setTimeout(() => initializeSlick(selector), 500);
          }
        } else {
          // Retry after a short delay if libraries aren't loaded yet
          setTimeout(() => initializeSlick(selector), 100);
        }
      }
    }

    // Initialize the first active slider
    initializeSlick(`.custom-category-slider[data-section-id="${sectionId}"] .slider-content.active .product-slider`);
    
    // Fallback: If slider doesn't initialize after 3 seconds, show products anyway
    setTimeout(() => {
      const activeSlider = $(`.custom-category-slider[data-section-id="${sectionId}"] .slider-content.active .product-slider`);
      if (activeSlider.length && !activeSlider.hasClass('slick-initialized')) {
        console.warn('Slider failed to initialize, showing products in fallback layout');
        activeSlider.css('display', 'flex');
        activeSlider.find('.slider-product-card').css({
          'flex': '0 0 calc(25% - 15px)',
          'min-width': '200px',
          'max-width': '300px'
        });
        activeSlider.find('.slider-loading').hide();
      }
    }, 3000);

    sliderSection.querySelectorAll('.tab-link').forEach(tab => {
      tab.addEventListener('click', function() {
        const tabId = this.dataset.tabId;

        // De-init sliders in inactive tabs
        sliderSection.querySelectorAll('.slider-content:not(.active) .product-slider.slick-initialized').forEach(slider => {
            $(slider).slick('unslick');
        });

        sliderSection.querySelectorAll('.tab-link').forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        sliderSection.querySelectorAll('.slider-content').forEach(content => {
          content.classList.remove('active');
          if (content.dataset.contentId === tabId) {
            content.classList.add('active');
          }
        });

        const activeSliderSelector = `.custom-category-slider[data-section-id="${sectionId}"] .slider-content.active .product-slider`;
        
        // Show loading indicator for the new active slider
        const activeSlider = $(activeSliderSelector);
        if (activeSlider.length && !activeSlider.hasClass('slick-initialized')) {
          activeSlider.find('.slider-loading').show();
          // Ensure the slider is visible for initialization
          activeSlider.css('display', 'block');
        }
        
        // Initialize with a small delay to ensure DOM is ready
        setTimeout(() => {
          initializeSlick(activeSliderSelector);
        }, 50);
      });
    });
  });

  // Re-initialize sliders when the theme editor is updated
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.custom-category-slider')) {
        // Re-run the logic for the loaded section
      }
    });
    document.addEventListener('shopify:section:reorder', function(event) {
       // Re-run logic if needed
    });
  }
}); 